import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(utc);
dayjs.extend(relativeTime);

const dayjsLocaleLoaders = {
  ar: () => import("dayjs/locale/ar"),
  cs: () => import("dayjs/locale/cs"),
  da: () => import("dayjs/locale/da"),
  de: () => import("dayjs/locale/de"),
  el: () => import("dayjs/locale/el"),
  es: () => import("dayjs/locale/es"),
  fr: () => import("dayjs/locale/fr"),
  hi: () => import("dayjs/locale/hi"),
  id: () => import("dayjs/locale/id"),
  it: () => import("dayjs/locale/it"),
  ja: () => import("dayjs/locale/ja"),
  ko: () => import("dayjs/locale/ko"),
  nl: () => import("dayjs/locale/nl"),
  no: () => import("dayjs/locale/nb"),
  pl: () => import("dayjs/locale/pl"),
  pt: () => import("dayjs/locale/pt"),
  ro: () => import("dayjs/locale/ro"),
  ru: () => import("dayjs/locale/ru"),
  sv: () => import("dayjs/locale/sv"),
  tr: () => import("dayjs/locale/tr"),
  uk: () => import("dayjs/locale/uk"),
  vi: () => import("dayjs/locale/vi"),
  zh: () => import("dayjs/locale/zh-cn"),
};

const dayjsLocaleMap = {
  no: "nb",
  zh: "zh-cn",
};

export const setDayjsLocale = async (locale = "en") => {
  if (locale === "en") {
    dayjs.locale("en");
    return "en";
  }

  const loader = dayjsLocaleLoaders[locale];
  const dayjsLocale = dayjsLocaleMap[locale] || locale;
  if (!loader) {
    dayjs.locale("en");
    return "en";
  }

  await loader();
  dayjs.locale(dayjsLocale);
  return dayjsLocale;
};

export default dayjs;
